import MmenuLight from 'mmenu-light';

const MenuMobile = {
  setMenuMobile: function () {
    const mmenuWrapper = document.querySelector('#mm-menu-mobile');
    const mmenu = new MmenuLight(mmenuWrapper);
    const menuItems = document.querySelectorAll('#mm-menu-mobile li.first-level');

    let lastOpenedItem = null; // Armazena o último item aberto

    menuItems.forEach((item) => {
      // Adiciona evento de clique apenas nos itens pai      
      item.addEventListener('click', function(event) {
        event.stopPropagation();

        const ulChild = item.querySelector('ul');
        if (ulChild !== null) {
          // Fecha o último item aberto, se houver
          if (lastOpenedItem && lastOpenedItem !== item) {
            lastOpenedItem.classList.remove('opened');
            lastOpenedItem.querySelector('ul').classList.remove('open');
          }

          // Alterna a classe 'opened' no item clicado
          item.classList.toggle('opened');
          ulChild.classList.toggle('open');

          // Atualiza o último item aberto
          if (item.classList.contains('opened')) {
            lastOpenedItem = item;
          } else {
            lastOpenedItem = null;
          }
        }
      });

      // Verifica se o item tem filhos
      if (item.querySelector('ul') !== null) {
        // Adiciona a classe 'hasChild' apenas aos itens pai com filhos
        item.classList.add('hasChild');
      }
    });

    const navigator = mmenu.navigation({
      title: 'Menu',
    });

    const drawer = mmenu.offcanvas();

    document
      .querySelector('[data-action="open-menu-mobile"]')
      .addEventListener('click', (e) => {
        e.preventDefault();
        drawer.open();
      });

    document
      .querySelector('[data-action="close-menu-mobile"]')
      .addEventListener('click', (e) => {
        e.preventDefault();
        drawer.close();
      });

    window.mmenu = drawer;
  },
  init: function () {
    const _this = this;
    _this.setMenuMobile();
  },
};

export default MenuMobile;
